import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Tabs, Tab } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import AddCard from './AddCard';
import Earning from './Earning';
import Earn from './Earn';
import Payments from './Payments';

const Financial = () => {
  const { t } = useTranslation();
  const [key, setKey] = useState('pay');
  const location = useLocation();
  useEffect(() => {
    let tab = location.state && location.state.tab ? location.state.tab : null;
    if (tab && key !== tab) {
      setKey(tab);
    }
  }, [location]);
  return (
    <div className="col p-0  financials">
      <Tabs activeKey={key} onSelect={k => setKey(k)} className="tabs">
        <Tab eventKey="Add card" title={t('Add card')}>
          <AddCard />
        </Tab>
        <Tab eventKey="Earn" title={t('Earn')}>
          <Earn />
        </Tab>
        <Tab eventKey="Payments" title={t('Payments')}>
          <Payments />
        </Tab>
        <Tab eventKey="Earnings" title={t('Earnings')}>
          <Earning />
        </Tab>
      </Tabs>
    </div>
  );
};

export default Financial;
